
<div class="w-full h-full max-w-full flex flex-col ">
        <div class="w-full flex justify-between">
                <div class="flex items-center"> <img src="../../assets/svg/powerGeneration.svg" alt="preview"> <span
                                class="font-normal  text-[#AEB9E1] sm:text-sm md:text-lg tracking-[2%] ml-1.5">{{"plant_generation"|
                                translate}}</span> </div>
                <div class="rounded-2xl p-3 bg-slate-600 text-white h-7 flex justify-center items-center w-fit mr-2.5 ">
                        7 Days</div>
        </div>
        <div class=" w-full min-w-0 mt-3 grow-1 relative h-[16rem] sm:h-[18rem] md:h-[22rem]
       ">
                @if (showChart() &&
                chartOptions &&
                chartOptions.chart?.type &&
                chartOptions.series &&
                chartOptions.series.length > 0
                ) {
                        <div #chartWrapper class="w-full h-full min-w-0 relative">
                <apx-chart class="w-full h-full  block " 
                #chart [series]="chartOptions.series!"
                        [chart]="chartOptions.chart!" [xaxis]="chartOptions.xaxis!" [yaxis]="chartOptions.yaxis!"
                        [tooltip]="chartOptions.tooltip!" [dataLabels]="chartOptions.dataLabels!"
                        [stroke]="chartOptions.stroke!" [plotOptions]="chartOptions.plotOptions!"
                        [grid]="chartOptions.grid!" [fill]="chartOptions.fill!" [markers]="chartOptions.markers!"
                        [tooltip]="chartOptions.tooltip!" [legend]="chartOptions.legend!"></apx-chart></div>
                } @else {

                <div class="flex flex-grow justify-center items-center sm:mt-16 md:mt-28 lg:mt-24">
                        <span class="text-xs dark:text-white">{{
                                "no_record_found" | translate
                                }}</span>
                </div>
                }


        </div>
</div>
